export default {
  action: '',
  templates: [],
  shippingCompanies: [],
  shippingServices: [],
  services: [],
  spreadsheets: [],
  table_data: null,
  loading: false,
  isModalOpen: false,
  links: {},
  meta: {}
}
